import { reactive } from 'vue'
import { getNews } from '../../api'

function useList() {
    let page = 1
    
    const app = reactive({
        loading: true,
        isNoMore: true,
        loadingMore: false,
        list: []
    })
    
    function _getNews(callback) {
        
        !callback && (app.loadingMore = true)
        
        getNews({page: page})
            .then(data => {
                app.list = app.list.concat(data.data)
                
                app.isNoMore = page === data.total_pages || data.total_pages < 1
    
                callback && callback()
            })
            .catch(err => { alert('Network Error') })
            .finally(err => {
                !callback && (app.loadingMore = false)
            })
    }
    
    _getNews(function () {
        app.loading = false
    })
    
    function loadMore() {
        if (app.loadingMore) return
        page++
        _getNews()
    }
    
    return {
        app,
        loadMore
    }
}

export {
    useList
}